<div class="buttons-group" [ngClass]="offset ? 'buttons-group--with-offset' : undefined">
  <ng-content></ng-content>
</div>
